import { filter } from 'lodash'
import { createTeamResourceContext } from './createTeamResourceContext'
import useNetworksResources from '../shared/resources/api/v1/admin/docker/useNetworksResources'

const { Provider: DockerNetworksProvider, useHook: useDockerNetworks } = createTeamResourceContext({
  name: 'DockerNetworks',
  useResources: useNetworksResources,
  responseKey: 'networks',
  lookups: [{ key: 'networksById', field: 'id' }],
  groupings: [{ key: 'networksByProjectId', field: 'projectId' }],
  computed: [
    {
      key: 'externalNetworks',
      fn: (networks) => filter(networks, { external: true }),
    },
  ],
})

export { DockerNetworksProvider, useDockerNetworks }
